import React from 'react';

import { colors, Fonts } from 'styles/theme';

export const RequiredAsterisk = () => (
    <Fonts.Small $color={colors.error}>{`*`}</Fonts.Small>
);
